<template>
  <el-dialog
    :title="`${title}信息编辑`"
    :visible.sync="dialogVisible"
    width="656px"
    :before-close="handleClose"
    :modal="true"
    :close-on-click-modal="false"
  >
    <div class="container-dialog">
      <div class="base-info">
        <div class="left">
          <img src="@/assets/image/street-icon.png" alt="" />
        </div>
        <div class="right">
          <div class="street">{{ curItem.pointName }}</div>
          <div class="community">
            {{ curItem.levelName1 }}
            {{ curItem.levelName2 ? "| " + curItem.levelName2 : "" }}
            {{ curItem.levelName3 ? "| " + curItem.levelName3 : "" }}
          </div>
        </div>
      </div>
      <el-form
        :model="formInline"
        ref="form"
        label-position="top"
        :rules="type == 1 ? rules1 : type == 2 ? rules2 : rules3"
      >
        <el-form-item label="街道介绍" v-if="type == 1" prop="briefInfo">
          <el-input
            type="textarea"
            show-word-limit
            style="white-space: pre-wrap;"
            ref="briefInfo"
            maxlength="2000"
            :autosize="{ minRows: 4, maxRows: 8 }"
            v-model="formInline.briefInfo"
            placeholder="街道介绍"
          ></el-input>
        </el-form-item>
        <el-form-item label="街区范围" v-if="type == 3" prop="blockScope">
          <el-input
            type="textarea"
            show-word-limit
            style="white-space: pre-wrap;"
            ref="blockScope"
            maxlength="2000"
            :autosize="{ minRows: 4, maxRows: 8 }"
            v-model="formInline.blockScope"
            placeholder="街区范围"
          ></el-input>
        </el-form-item>
        <div style="display: flex;">
          <el-form-item
            label="楼栋数"
            style="margin-right: 24px;"
            prop="buildingInfo"
          >
            <el-input
              type="number"
              placeholder="请输入楼栋数"
              v-model="formInline.buildingInfo"
            >
              <template slot="append">栋</template>
            </el-input>
          </el-form-item>
          <el-form-item label="面积" prop="areaInfo">
            <el-input
              type="number"
              placeholder="面积"
              v-model="formInline.areaInfo"
            >
              <template slot="append">平方公里</template>
            </el-input>
          </el-form-item>
          <el-form-item
            style="margin-left: 24px;"
            v-if="type == 3"
            label="街区人口"
            prop="population"
          >
            <el-input
              type="number"
              placeholder="街区人口"
              v-model="formInline.population"
            >
              <template slot="append">人</template>
            </el-input>
          </el-form-item>
        </div>
        <el-form-item label="点位类型" prop="pointType">
          <el-select
            placeholder="请选择点位类型"
            v-model="formInline.pointType"
            filterable
          >
            <el-option
              v-for="item in pointType"
              :key="item.id"
              :label="item.typeName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="网格长" prop="streetChief">
          <el-select
            v-model="formInline.streetChief"
            filterable
            allow-create
            default-first-option
            placeholder="请选择网格长"
            @change="selectStreet"
          >
            <el-option
              v-for="(item, index) in leaderNameOptions"
              :key="item.id"
              :label="item.userName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="副网格长">
          <el-select
            placeholder="请选择网格长"
            v-model="formInline.fuStreetChief"
            filterable
            multiple
          >
            <el-option
              v-for="item in leaderNameOptions"
              :key="item.id"
              :label="item.userName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="咨询、监督电话" prop="consultationHotline">
          <el-select
            v-model="formInline.consultationHotline"
            multiple
            filterable
            allow-create
            default-first-option
            placeholder="请输入咨询、监督电话"
          >
            <el-option
              v-for="(item, index) in options"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="updatePointLevelFun">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { updatePointLevel } from "@/api/base.js";
import { getPointTypeListPage, getIIamUseroAll } from "@/api/point.js";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    curItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      formInline: {
        blockScope: "",
        buildingInfo: "",
        briefInfo: "",
        areaInfo: "",
        pointType: "",
        population: "",
        consultationHotline: [],
        id: "",
        streetChief: "",
        fuStreetChief: []
      },
      title: "",
      options: [],
      type: 1,
      rules1: {
        // briefInfo: [
        //   { required: true, message: "请输入街道介绍", trigger: "blur" }
        // ],
        // buildingInfo: [
        //   { required: true, message: "请输入楼栋数", trigger: "blur" }
        // ],
        // areaInfo: [{ required: true, message: "请输入面积", trigger: "blur" }],
        // pointType: [
        //   { required: true, message: "请选择点位类型", trigger: "blur" }
        // ],
        // consultationHotline: [
        //   { required: true, message: "请输入咨询、监督电话", trigger: "blur" }
        // ]
      },
      rules2: {
        // buildingInfo: [
        //   { required: true, message: "请输入楼栋数", trigger: "blur" }
        // ],
        // areaInfo: [{ required: true, message: "请输入面积", trigger: "blur" }],
        // pointType: [
        //   { required: true, message: "请选择点位类型", trigger: "blur" }
        // ],
        // consultationHotline: [
        //   { required: true, message: "请输入咨询、监督电话", trigger: "blur" }
        // ]
      },
      rules3: {
        // blockScope: [
        //   { required: true, message: "请输入街区范围", trigger: "blur" }
        // ],
        // buildingInfo: [
        //   { required: true, message: "请输入楼栋数", trigger: "blur" }
        // ],
        // areaInfo: [{ required: true, message: "请输入面积", trigger: "blur" }],
        // pointType: [
        //   { required: true, message: "请选择点位类型", trigger: "blur" }
        // ],
        // population: [
        //   { required: true, message: "请输入街区人口", trigger: "blur" }
        // ],
        // consultationHotline: [
        //   { required: true, message: "请输入咨询、监督电话", trigger: "blur" }
        // ]
      },
      pointType: [],
      leaderNameOptions: []
    };
  },
  mounted() {
    this.getPointTypeListPageFun();
    this.getIIamUseroAllFun();
    this.title = this.curItem.pointName;
    if (this.curItem.levelName1) {
      this.type = 1;
    }
    if (this.curItem.levelName2) {
      this.type = 2;
    }
    if (this.curItem.levelName3) {
      this.type = 3;
    }
    this.options = this.curItem.consultationHotline
      ? JSON.parse(this.curItem.consultationHotline).map(item => item.phone)
      : [];

    this.formInline = {
      blockScope: this.curItem.blockScope,
      buildingInfo: this.curItem.buildingInfo,
      population: this.curItem.population,
      areaInfo: this.curItem.areaInfo,
      pointType: this.curItem.pointType,
      briefInfo: this.curItem.briefInfo,
      fuStreetChief:
        this.curItem.fuStreetChiefInfo && this.curItem.fuStreetChiefInfo.length
          ? this.curItem.fuStreetChiefInfo.map(item => item.id)
          : "",
      consultationHotline: this.curItem.consultationHotline
        ? JSON.parse(this.curItem.consultationHotline).map(item => item.phone)
        : [],
      streetChief: this.curItem.streetChief
    };
  },
  methods: {
    selectStreet(val) {
      console.log(val, 999);
      this.options = this.leaderNameOptions
        .filter(item => item.id == val)
        .map(item => item.phone);
      this.formInline.consultationHotline = this.options;
    },
    async getIIamUseroAllFun() {
      const res = await getIIamUseroAll();
      this.leaderNameOptions = res.data.data;
    },
    async getPointTypeListPageFun() {
      const res = await getPointTypeListPage({
        enableStatus: 0,
        page: 1,
        size: 9999
      });
      this.pointType = res.data.data.records;
    },
    handleClose() {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit("update:dialogVisible", false);
    },
    async updatePointLevelFun() {
      let xx = true;
      this.$refs["form"].validate(valid => {
        if (valid) {
          xx = true;
        } else {
          xx = false;
        }
      });
      if (xx == false) {
        this.$message({
          message: "请输入或选择必填项",
          type: "warning"
        });
        return false;
      }
      let consultationHotline = [];
      if (this.formInline.consultationHotline.length) {
        this.formInline.consultationHotline.forEach(item => {
          consultationHotline.push({
            phone: item
          });
        });
      }
      let params = {
        buildingInfo: this.formInline.buildingInfo,
        blockScope: this.formInline.blockScope,
        areaInfo: this.formInline.areaInfo,
        pointType: this.formInline.pointType,
        levelName3: this.curItem.levelName3,
        levelName2: this.curItem.levelName2,
        levelName1: this.curItem.levelName1,
        pointName: this.curItem.pointName,
        population: this.formInline.population,
        briefInfo: this.formInline.briefInfo,
        fuStreetChief:
          this.formInline.fuStreetChief && this.formInline.fuStreetChief.length
            ? this.formInline.fuStreetChief.toString()
            : null,
        id: this.curItem.id,
        consultationHotline: consultationHotline.length
          ? JSON.stringify(consultationHotline)
          : "",
        streetChief: this.formInline.streetChief
      };
      const res = await updatePointLevel(params);
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.handleClose();
        this.$emit("refreshList", this.type);
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    }
  },
  computed: {},
  watch: {
    "formInline.briefInfo": {
      deep: true,
      handler: function(newVal, oldVal) {
        if (!!!newVal) return;

        this.$nextTick(() => {
          const inputElement = this.$refs.briefInfo.$el.querySelector(
            "textarea"
          );
          const cursorPosition = inputElement.selectionStart;
          this.formInline.briefInfo = newVal.replace(/ /g, "\u3000");
          inputElement.setSelectionRange(cursorPosition, cursorPosition);
        });
      }
    },
    "formInline.blockScope": {
      deep: true,
      handler: function(newVal, oldVal) {
        if (!!!newVal) return;

        this.$nextTick(() => {
          const inputElement = this.$refs.blockScope.$el.querySelector(
            "textarea"
          );
          const cursorPosition = inputElement.selectionStart;
          this.formInline.blockScope = newVal.replace(/ /g, "\u3000");
          inputElement.setSelectionRange(cursorPosition, cursorPosition);
        });
      }
    }
  }
};
</script>

<style scoped lang="less">
/deep/.el-dialog .el-dialog__header {
  border: none;
  height: 64px;
  padding: 24px 16px 16px 24px;
  background: url("~@/assets/image/dialog-top-bg1.png") center no-repeat;
  background-size: 100% 100%;

  .el-dialog__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #494c4f;
  }
}

/deep/.el-form-item__label {
  margin: 0;
  padding: 0;
}

/deep/.el-dialog__body {
  padding: 24px;
  padding-top: 0;
}

.base-info {
  display: flex;
  align-items: center;
  width: 100%;
  height: 72px;

  .left {
    width: 72px;
    height: 72px;
    margin-right: 16px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .right {
    .street {
      font-family: MiSans, MiSans;
      font-weight: 700;
      font-size: 24px;
      color: #494c4f;
    }

    .community {
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 16px;
      color: #0090ff;
      margin-top: 8px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/baseInfo/baseInfo/components/streetDialog.vue